import { estimateFeesPerGas } from "@wagmi/core";
import { parseGwei } from "viem";

export const ccWalletGasOverrides = {
  // gas: 350000n,
  maxPriorityFeePerGas: parseGwei("3"),
  maxFeePerGas: parseGwei("5"),
} as const;

export async function getCcWalletGasOverrides(
  config: Parameters<typeof estimateFeesPerGas>[0],
  chainId: number
) {
  try {
    const fees = await estimateFeesPerGas(config, { chainId });
    const maxPriorityFeePerGas =
      fees.maxPriorityFeePerGas && fees.maxPriorityFeePerGas > 0n
        ? fees.maxPriorityFeePerGas
        : ccWalletGasOverrides.maxPriorityFeePerGas;
    const maxFeePerGas =
      fees.maxFeePerGas && fees.maxFeePerGas > 0n
        ? fees.maxFeePerGas
        : ccWalletGasOverrides.maxFeePerGas;

    return {
      maxPriorityFeePerGas,
      maxFeePerGas:
        maxFeePerGas >= maxPriorityFeePerGas
          ? maxFeePerGas
          : maxPriorityFeePerGas,
    };
  } catch (error) {
    console.warn("get cc wallet gas overrides failed, use fallback", error);
    return ccWalletGasOverrides;
  }
}
